import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["name", "csm", "building", "company", "unit"]

  connect() {
    // avoid disabled selectize fields
    setTimeout(() => this.update())
  }

  update() {
    this.fields("csm", ["admin"])
    this.fields("building", ["property_admin", "community_admin", "front_desk_attendant", "installer"])
    this.fields("company", ["company_admin"])
    this.fields("unit", ["unit_admin", "tenant"])
  }

  fields(target, roles) {
    this[`${target}Target`].toggleAttribute("disabled", !roles.includes(this.name))
  }

  get name() {
    return this.nameTarget.value
  }
}
